/**
 * Schema.org JSON-LD.
 *
 * Pure data builders — no React — so they can be unit-tested.
 *
 * The FAQ page's own FAQPage markup is not here: faqContent.js already exports
 * buildFaqJsonLd, generated from the same array the page renders, which is what
 * keeps the marked-up answers identical to the visible ones.
 *
 * DELIBERATELY NOT USED: FinancialProduct, LoanOrCredit, or any of their
 * subtypes. Those types assert in machine-readable form that this site offers
 * a loan. MyCaseLoan is a marketplace, not a lender, and REDESIGN.md §4.6 and
 * the FAQ both say so in terms that were legally reviewed. Structured data is
 * a claim like any other — it should not say something the page denies.
 */
import { PAGE_META, SITE_URL } from './pageMeta';

const LEGAL_NAME = 'My Case Loan, LLC';

/**
 * Organization + WebSite for the homepage.
 *
 * Only facts that appear elsewhere on the site: the legal entity from the
 * Terms, the canonical origin, and the homepage description. No address, phone
 * or social profiles — we do not publish any, and inventing them to fill the
 * schema would be worse than omitting them.
 */
export const organizationLd = () => [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${SITE_URL}/#organization`,
    name: 'MyCaseLoan',
    legalName: LEGAL_NAME,
    url: `${SITE_URL}/`,
    logo: `${SITE_URL}/favicon-192.png`,
    description: PAGE_META.home.description,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    name: 'MyCaseLoan',
    url: `${SITE_URL}/`,
    description: PAGE_META.home.description,
    publisher: { '@id': `${SITE_URL}/#organization` },
  },
];
